import { render } from "./AddEdi.vue?vue&type=template&id=81c0ac08"
import script from "./AddEdi.vue?vue&type=script&lang=js"
export * from "./AddEdi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__